import { Release } from "shared-ts-release";
import { Typography } from "@mui/material";
import diagram_max_temperature from "./diagram_max_temperature.png";
import filter from "./filter.png";
import column_groups from "./column_groups.png";

export const release_2025_2_0: Release = {
  version: "2025.2.0",
  date: "2025-10-27",
  entries: [
    {
      type: "Feature",
      heading: "Nytt nøkkeltall: Gjennomsnittlig maksimal-temperatur",
      description: (
        <Typography>
          Vi har lagt til et nytt nøkkeltall som viser gjennomsnittlig
          maksimaltemperatur for røykløpet, for bedre innsikt i
          temperaturutviklingen.
        </Typography>
      ),
    },
    {
      type: "Feature",
      heading:
        "Nytt diagram for visning av maksimums-temperaturer for et røykløp",
      description: (
        <>
          <Typography>
            I visningen for et røykløp, under fanen Temperaturalarm, kan du nå
            se både maksimal og gjennomsnittlig maksimal-temperatur per måned.
          </Typography>
          <img
            src={diagram_max_temperature}
            alt={"diagram_max_temperature"}
            width={"100%"}
            style={{ marginTop: "1em", marginBottom: "0.5em" }}
          />
        </>
      ),
    },
    {
      type: "Improvement",
      heading: "Forbedret registrering av feiinger",
      description: (
        <>
          <Typography>
            Vi har forbedret registrering av feiinger. Registreringen skal nå
            være mer forståelig.
          </Typography>
        </>
      ),
    },
    {
      type: "Usability",
      heading:
        "Pipe-status-tabellen og Sensor-status-tabellen har nå støtte for filtrering",
      description: (
        <>
          <Typography>
            I visningen for et røykløp, under fanen Temperaturalarm, kan du nå
            se både maksimal og gjennomsnittlig maksimal-temperatur per måned.
          </Typography>
          <img
            src={filter}
            alt={"filter"}
            width={"100%"}
            style={{ marginTop: "1em", marginBottom: "0.5em" }}
          />
        </>
      ),
    },
    {
      type: "Usability",
      heading:
        "Pipe-status-tabellen og Sensor-status-tabellen har fått kolonne-grupper",
      description: (
        <>
          <Typography>
            Kolonne-gruppene gjør det lettere å få oversikt i tabellen
          </Typography>
          <img
            src={column_groups}
            alt={"filter"}
            width={"100%"}
            style={{ marginTop: "1em", marginBottom: "0.5em" }}
          />
        </>
      ),
    },
    {
      type: "Usability",
      heading:
        "Pipe-status-tabellen og Sensor-status-tabellen husker justerte kolonne-bredder",
      description:
        "Har du justert kolonne-bredden på en kollonne, " +
        "så vil den nå bli husket til neste gang.",
    },
  ],
};
